import apiClient from './api/apiClient';

export interface CoffeeChatBanner {
  banner_id: number;
  title: string;
  description: string;
  font_color_hex_code: string;
  banner_image_url: string;
}

export interface CoffeeChatBannerResponse {
  code: number;
  status: string;
  message: string;
  data: CoffeeChatBanner[];
}

export const coffeeChatBannerApi = {
  // 커피챗 배너 목록 조회
  getCoffeeChatBanners: async (): Promise<CoffeeChatBanner[]> => {
    try {
      const response = await apiClient.get<CoffeeChatBannerResponse>('/api/ui/coffee-chat/banners/list');
      return response.data.data;
    } catch (error: any) {
      /// console.error('커피챗 배너 데이터 로딩 실패:', error);
      throw error;
    }
  }
};
